<template>
    <v-sheet dark tile>
        <v-content>
            <v-row no-gutters>
                <v-col align="center">
                    <span class="display-1 color-primario">
                        <h2>Conocenos</h2>
                    </span>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="12" md="4" sm="6" xs="6" v-for="(razon, i) in razones" :key="i">
                        <v-card flat>
                            <v-card-title>
                                <v-row>
                                    <v-col align="center">
                                        <span class="title color-primario text-center">
                                            {{ razon.titulo }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text align="center">
                                <span>{{ razon.contenido }}</span>
                            </v-card-text>
                        </v-card>
                </v-col>
            </v-row>
        </v-content>
    </v-sheet>
</template>

<script>
export default {
  name: 'App',
  created(){
    this.$vuetify.theme.dark = true
  },
  computed: {
  },
  components: {
  },

  data() {
    return {
        razones: [
            { 
              titulo:  'Lealtad',
              contenido: 'Estamos para nuestros clientes siempre y en todo momento.'
            },
            { 
              titulo:  'Elígenos',
              contenido: 'La calidad y el compromiso nos diferencian de cualquier otra compañia.'
            },
            { 
              titulo:  'Aprende y construye',
              contenido: 'No solo te ayudamos, te ensañamos a estar preparado y actualizado ante las nuevas tecnologias.'
            }
        ]
    }
  },
};
</script>

<style>
.color-primario{
    color: #085f66;
}
</style>